export const ENG = "en";
export const PTR = "pt";
